import * as React from "react";
import { useIntl, useDispatch, useSelector } from "@grandvisionhq/state";
import { ShippingObjectTypes } from "../../../../state.js";
import { toggleInvoice } from "../../../StepShipping/actions.js";
import { getCompany, getInvoiceFormEnabledState } from "../../../StepShipping/selectors.js";
import { InvoiceFormComponent } from "../../../components/StepShipping/components/InvoiceForm.js";
import { useIsFormSlotAvailable } from "../../../../slots/forms/slots/forms/form-context.js";
const InvoiceFormContainer = () => {
  const { getLabel } = useIntl();
  const dispatch = useDispatch();
  const company = useSelector(getCompany);
  const isInvoiceFormEnabled = useSelector(getInvoiceFormEnabledState);
  const isInvoiceFormAvailable = useIsFormSlotAvailable(ShippingObjectTypes.Invoice);
  React.useEffect(() => {
    if (isInvoiceFormAvailable && !company && !isInvoiceFormEnabled) {
      dispatch(toggleInvoice({ enabled: true }));
    }
    if (!isInvoiceFormAvailable && isInvoiceFormEnabled) {
      dispatch(toggleInvoice({ enabled: false }));
    }
  }, [isInvoiceFormAvailable, company, isInvoiceFormEnabled]);
  const labels = React.useMemo(
    () => ({
      invoiceTitle: getLabel("checkout.invoice.title")
    }),
    [getLabel]
  );
  if (company) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(InvoiceFormComponent, { title: labels.invoiceTitle });
};
export {
  InvoiceFormContainer
};
//# sourceMappingURL=InvoiceFormContainer.js.map
